import { IonIcon, } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import { withTranslation } from '../../lib/translate';
import { validateProfileData } from '../../lib/utils';
import { setModal } from '../../store/actions';
import { NormalText, Spacer } from '../common';
import './index.css';
import { alertCircle } from 'ionicons/icons';

const ValidateButton = ({ __, dispatch, profile, auth, withSpacer = false }) => {
  const isAuth = auth.loggedIn;
  const valid = validateProfileData(profile).isValid;
  if (!getConfig().appType.hasEmailValidationEnabled) {
    return null;
  }
  return (
    <>
      {isAuth && !valid ? (
        <>
          <div onClick={() => dispatch(setModal('isVerfiedModalOpen', true))} className=" validate-button pointer">
            <IonIcon color='danger' icon={alertCircle} />
            <NormalText className="validate-status label-color">{__("Your account isn't verified.")}</NormalText>
          </div>
          {withSpacer && <Spacer size={5} />}
        </>
      ) : null}
    </>
  );
};

const stateToProps = (store) => {
  const { isVerfiedModalOpen, profile, auth } = store.profile;
  return {
    isVerfiedModalOpen,
    profile,
    auth,
  };
};

export default connect(stateToProps)(withRouter(withTranslation(ValidateButton)));
